import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import styles from '../Billing/styles/MyBillsTableRow.module.scss';

import Box from '../Common/Box';

// Types.
import { TransactionHistoryEventUI } from '../../types/evCharging';
// Utils.
import { formatFullDateTime, setPriceFormat, roundNumber } from '../../utils/billing';
import { useWindowSize } from '../Layout/Header';

type ChargingHistoryTableRowType = {
  charge: TransactionHistoryEventUI;
};

const ChargingHistoryTableRow: React.FunctionComponent<ChargingHistoryTableRowType> = (props: ChargingHistoryTableRowType) => {
  const { t } = useTranslation();

  const { charge } = props;

  const windowWidth = useWindowSize()[0];
  const isMobile = windowWidth < 768;

  const formattedPrice = `${setPriceFormat(roundNumber(charge.totalCostInclVat))} €`;

  if (isMobile) {
    return (
      <Box className={`${styles.boxLink}`}>
        <Link to={`/evCharging/history/${charge.evseTransactionId}`}>
          <div>
            <div className={styles.detail}>
              <span>{t('evCharging:history.tableAmount')}</span>
              <span>{setPriceFormat(roundNumber(charge.consumptionKWH))} kWh</span>
            </div>
            <div className={styles.detail}>
              <span>{t('evCharging:history.tablePrice')}</span>
              <span>{formattedPrice}</span>
            </div>
            <div className={styles.detail}>
              <span>{t('evCharging:history.tableDate')}</span>
              <span>{formatFullDateTime(new Date(charge.startTimeUTC).valueOf(), true)}</span>
            </div>
          </div>
          <span />
        </Link>
      </Box>
    );
  } else {
    return (
      <div className={styles.item}>
        <div>{charge.groupName}</div>
        <div>{setPriceFormat(roundNumber(charge.consumptionKWH))} kWh</div>
        <div>{formatFullDateTime(new Date(charge.startTimeUTC).valueOf(), true)}</div>
        <div>{formattedPrice}</div>
        <div>
          <Link className={`${styles.link} underline`} to={`/evCharging/history/${charge.evseTransactionId}`}>
            {t(`evCharging:history.tableOpen`)}
          </Link>
        </div>
      </div>
    );
  }
};

export default ChargingHistoryTableRow;
